
import { useTranslation } from 'react-i18next';
import AffiliateContainer from '../../dynamic_section/dynamic_1/template_01';
import AffiliateBanner from '../../dynamic_section/dynamic_2/template_01';
// import { Navigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive';
import "./template_01.css";


const AffiliatePage = (props) => {

  const { t } = useTranslation();

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  return (
    <section id="affiliate_01">
      <div className="affiliate_body" >
        <AffiliateBanner desktopToggle={true} mobileToggle={false} label={'mainpage_affiliate_banner'} id={'mainpage_affiliate_banner'} supportLanguage={false} titleToggle={false} addContainer={false} titleIconToggle={true} linkTo={``} />
        <AffiliateBanner desktopToggle={false} mobileToggle={true} label={'mainpage_affiliate_banner_m'} id={'mainpage_affiliate_banner_m'} supportLanguage={false} titleToggle={false} addContainer={false} titleIconToggle={true} linkTo={``} />
        <div className={`affiliate_button_wrap ${isDesktopOrLaptop?'':'affiliate_button_wrap_m'}`}>
            <button type='button' className='color_button font_button affiliateButton inviteButton'>{t('invite')}</button>
            <button type='button' className='color_button font_button affiliateButton downlineButton'>{t('downline')}</button>
        </div>
        
      </div>
    </section>
  );
}

export default AffiliatePage;
